import { memo } from "react";
import { useTranslation } from "react-i18next";
import {
  AuraLayout,
  BodyCopy,
  Button,
  ElevatedCircle,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { ErrorIcon } from "lola-framework-ui-test/src/icons";
import { useStore } from "../../../store/globalState";
import { useCallbackUrl } from "../../../store/usePartnerStore";
import {
  flavorClassName,
} from "../../../constants";

export const ServiceUnavailablePage = memo(() => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const callbackUrl = useCallbackUrl();

  const colorConfig = theme.errorView;
  const {
    backgroundBtn,
    textColorBtn,
    dropzoneColors,
    title,
    bodyCopy,
    buttonShowIcon,
    buttonSize,
  } = colorConfig;

  const handleGoToApp = () => {
    window.location.href = callbackUrl;
  };

  return (
    <AuraLayout colorConfig={colorConfig} className={`${flavorClassName}`}>
      <Layout.Content className="landing-section error-page">
        <ElevatedCircle
          shadowVariant="inset"
        >
          <ErrorIcon size={35} colors={dropzoneColors} />
        </ElevatedCircle>
        <section className="landing-container">
          <PageTitle
            highlight={t("error.serviceUnavailableTitle")}
            highlightColor={title}
            secudnary=""
            secudnaryColor={title}
          />
          <BodyCopy style={{ color: bodyCopy }}>
            {t("error.serviceUnavailableMessage")}
          </BodyCopy>
        </section>
      </Layout.Content>
      <Layout.Footer>
        <section className="footer-section">
          <Button
            background={backgroundBtn}
            color={textColorBtn}
            showIcon={buttonShowIcon}
            size={buttonSize ?? "small"}
            onClick={handleGoToApp}
          >
            {t("error.goToApp")}
          </Button>
        </section>
      </Layout.Footer>
    </AuraLayout>
  );
});
